export default __webpack_public_path__ + "static/media/bg.1b7653ac.jpg";